import Head from 'next/head';
import { Fragment, type PropsWithChildren } from 'react';

import Spacer from '@/components/Spacer';

const EmptyLayout: React.FC<PropsWithChildren> = ({ children }) => (
  <Fragment>
    <Head>
      <link rel='icon' href='/favicon-32x32.png' />
    </Head>
    {children}
    <Spacer size={80} />
  </Fragment>
);

export default EmptyLayout;
